import ApiService from "@/core/services/api.service";

// action types
export const GET_METHODS = "getMethods";
export const CREATE_ORDER = "createOrder";
export const UPDATE_ORDER = "updateOrder";
export const CREATE_ORDER_DOCUMENTS = "createOrderDocuments";
export const PROCESS_ORDER_DOCUMENTS = "processOrderDocuments";
export const CREATE_CREDIT = "createCredit";
export const GET_ORDERS = "getOrders";
export const GET_ORDERS_HISTORY = "getOrdersHistory";
export const GET_ORDERS_HISTORY_EXCEL = "getOrdersHistoryExcel";
export const GET_ORDERS_HISTORY_EXCEL_DETALLE ="getOrdersHistoryExcelDetalle";
export const GET_ORDERS_HISTORY_NO_PAGADAS_EXCEL_DETALLE ="getOrdersHistoryNoPagadasExcelDetalle";
export const GET_ORDERS_HISTORY_NO_PAGADAS_EBSO_EXCEL_DETALLE ="getOrdersHistoryNoPagadasEbsoExcelDetalle";
export const GET_ORDERS_HISTORY_ERROR = "getOrdersHistoryError";
export const GET_ORDERS_HISTORY_ERROR_EBSO = "getOrdersHistoryErrorEbso";
export const GET_ORDER_TOKEN= "getOrderToken";
export const GET_ORDER = "getOrder";
export const GET_PDF = "getPdf";
export const GET_PDF_FACTURA = "getPdfFactura";
export const SEND_PDF = "sendPdf";
export const GET_DETAILS = "getDetails";
export const ORDER_REQUEST_APPROVE = "orderRequestApprove";
export const ORDER_APPROVE = "orderApprove";
// mutation types
export const SET_METHODS = "setMethods";
export const SET_ORDERS = "setOrders";
export const SET_ORDERS_ERROR = "setOrdersError";
export const SET_ORDERS_ERROR_EBSO = "setOrdersErrorEbso";
export const SET_ORDER = "setOrder";
export const SET_DETAILS = "setDetails";
export const SET_ERROR = "setError";

const state = {
  errors: null,
  methods: [],
  orders:{ordenesPago:[]},
  order:{},
  details:[]
};

const actions = {
  [GET_METHODS](context) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get({action: `/api/OrdenPago/v1/orden/medios`}, '')
        .then(({ data }) => {
          context.commit(SET_METHODS, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  },
  [GET_ORDERS](context, params) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.query({action: `/api/OrdenPago/v1/ordenes`}, params)
        .then(({ data }) => {
          if(data.length==0)
            data = null;
          context.commit(SET_ORDERS, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log('err' + response);
          context.commit(SET_ERROR, '');//response.data.errors);
          resolve(response.data);
        });
    });
  },
  [GET_ORDERS_HISTORY_ERROR](context, params) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.query({action: `/api/OrdenPago/v1/ordenes/nopagadas/historia`}, params)
        .then(({ data }) => {
          if(data.length==0)
            data = null;
          context.commit(SET_ORDERS, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log('err' + response);
          context.commit(SET_ERROR, '');//response.data.errors);
        });
    });
  },
  [GET_ORDERS_HISTORY_ERROR_EBSO](context, params) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.query({action: `/api/OrdenPago/v1/ordenes/nopagadas/historia/ebso`}, params)
        .then(({ data }) => {
          if(data.length==0)
            data = null;
            console.log(data)
          context.commit(SET_ORDERS, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log('err' + response);
          context.commit(SET_ERROR, '');//response.data.errors);
        });
    });
  },
  [GET_ORDERS_HISTORY](context, params) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.query({action: `/api/OrdenPago/v1/ordenes/historia`}, params)
        .then(({ data }) => {
          if(data.length==0)
            data = null;

          console.log(data)
          context.commit(SET_ORDERS, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log('err' + response);
          context.commit(SET_ERROR, '');//response.data.errors);
        });
    });
  },
  [GET_ORDERS_HISTORY_EXCEL](context, params) {
    return new Promise(resolve => {

      ApiService.setHeader();
      ApiService.query({action: `/api/OrdenPago/v1/ordenes/historia/excel`}, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          console.log('err' + response);
          context.commit(SET_ERROR, '');//response.data.errors);
        });
    });
  },
  [GET_ORDERS_HISTORY_EXCEL_DETALLE](context, params) {
    return new Promise(resolve => {

      ApiService.setHeader();
      ApiService.query({action: `/api/OrdenPago/v1/ordenes/historia/excelDetalle`}, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          console.log('err' + response);
          context.commit(SET_ERROR, '');//response.data.errors);
        });
    });
  },
  [GET_ORDERS_HISTORY_NO_PAGADAS_EXCEL_DETALLE](context, params) {
    return new Promise(resolve => {

      ApiService.setHeader();
      ApiService.query({action: `/api/OrdenPago/v1/ordenes/historia/excelDetalle/nopagadas`}, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          console.log('err' + response);
          context.commit(SET_ERROR, '');//response.data.errors);
        });
    });
  },
  [GET_ORDERS_HISTORY_NO_PAGADAS_EBSO_EXCEL_DETALLE](context, params) {
    return new Promise(resolve => {

      ApiService.setHeader();
      ApiService.query({action: `/api/OrdenPago/v1/ordenes/historia/excelDetalle/nopagadasebso`}, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          console.log('err' + response);
          context.commit(SET_ERROR, '');//response.data.errors);
        });
    });
  },
  [ORDER_REQUEST_APPROVE](context, ordenId) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get({action: `/api/OrdenPago/v1/orden/${ordenId}/solicitaAprobacion`}, '')
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          console.log('err' + response);
          context.commit(SET_ERROR, '');//response.data.errors);
        });
    });
  },

  [ORDER_APPROVE](context, orden) {
    return new Promise((resolve, reject) => {
      ApiService.setHeader();
      ApiService.put({action: `/api/OrdenPago/v1/orden/${orden.ordenId}/aprobarPagoExterno`}, orden)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response.data);
        });
    });
  },

  [GET_ORDER](context, codigo) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get({action: `/api/OrdenPago/v1/orden/${codigo}/get`}, '')
        .then(({ data }) => {
          context.commit(SET_ORDER, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log('err' + response);
          context.commit(SET_ERROR, '');//response.data.errors);
        });
    });
  },
  [GET_ORDER_TOKEN](context, codigo) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get({action: `/api/OrdenPago/v1/orden/${codigo}`}, '')
        .then(({ data }) => {
          context.commit(SET_ORDER, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  },
  [GET_DETAILS](context, token) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get({action: `/api/OrdenPago/v1/orden/${token}/detalle`}, '')
        .then(({ data }) => {
          context.commit(SET_DETAILS, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  },
  [GET_PDF](context, token) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.query({action: `/api/OrdenPago/v1/orden/${token}/pdf`}, {responseType: 'blob'})
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  },
  [SEND_PDF](context, order) {
    console.log(JSON.stringify(order));
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.post({action: `/api/OrdenPago/v1/orden/${order.tokenOrden}/send`}, order)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  },
  [UPDATE_ORDER](context, order) {
    return new Promise((resolve, reject) => {
      ApiService.setHeader();
      ApiService.put({action: `/api/OrdenPago/v1/descuentos/${order.tokenOrden}`},  order)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, { errors: ["No se ha podido iniciar el proceso de pago"] } );//response.data.errors);
          reject(response)
        });
    });
  },

  [CREATE_ORDER](context, order) {
    return new Promise((resolve, reject) => {
      ApiService.setHeader();
      ApiService.post({action: `/api/OrdenPago/v1/orden/iniciarPago`},  order)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, { errors: ["The login detail is incorrect"] } );//response.data.errors);
          reject(response)
        });
    });
  },
  [CREATE_ORDER_DOCUMENTS](context, order) {
    return new Promise((resolve, reject) => {
      ApiService.setHeader();
      ApiService.post({action: `/api/OrdenPago/v1/orden/iniciarPagoPedido`},  order)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, { errors: ["The login detail is incorrect"] } );//response.data.errors);
          reject(response)
        });
    });
  },
  [PROCESS_ORDER_DOCUMENTS](context, order) {
    return new Promise((resolve, reject) => {
      ApiService.setHeader();
      ApiService.put({action: `/api/OrdenPago/v1/orden/iniciarPagoPedidoExterno/${order.token}`},  order)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, { errors: ["The login detail is incorrect"] } );//response.data.errors);
          reject(response)
        });
    });
  },
  [CREATE_CREDIT](context, order) {
    return new Promise((resolve, reject) => {
      ApiService.setHeader();
      ApiService.post({action: `/api/OrdenPago/v1/orden/iniciarPagoCredito`},  order)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, ["No hemos podido iniciar el proceso de pago"]);//response.data.errors);
          reject(response)
        });
    });
  },
  [GET_PDF_FACTURA](context, item) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get({action: `/api/OrdenPago/v1/ordenPago/pdfFactura/${item.numeroDocumento}/${item.codigoTipoDocumento}`})
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  },
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_METHODS](state, methods) {
    state.error = {};
    state.methods = methods.mediosPago;
  },
  [SET_ORDERS](state, orders) {
    state.error = {};
    state.orders = orders;
  },
  [SET_DETAILS](state, details) {
    state.error = {};
    state.details = details;
  },
  [SET_ORDER](state, data) {
    state.error = {};
    state.order = data;
  }
};

export default {
  state,
  actions,
  mutations
};
